export default function Logo({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-label="Skloccom logo" role="img">
      <rect width="64" height="64" rx="14" fill="#1A2E20" />
      <path d="M45 16c-15 1-26 11-26 25 0 3 .7 5.6 1.8 7.4C29.5 45 40.5 35 45 16z" fill="#72B043" />
      <path d="M22 47c8.5-8.5 16.5-18.5 21-27" stroke="#FBF9F5" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      <circle cx="46" cy="47" r="3" fill="#C86D51" />
    </svg>
  );
}
